<template>
  <div>
    <vxe-card class="card-container" size="small" title="" width="100%">
      <template #title>
        <compact-form :data="taskData" :items="taskItems" style="width: 90%"/>
      </template>
      <!--          <a-descriptions :column="4" style="margin-bottom: -15px">-->
      <!--            <a-descriptions-item :label="$t('business.label.workstation')">-->
      <!--              <a-input v-model="zoneNo" @pressEnter="onPressEnterZoneNo()"/>-->
      <!--            </a-descriptions-item>-->
      <!--            <a-descriptions-item :label="$t('business.label.scanContainer')">-->
      <!--              <a-input ref="containerNo" v-model="containerNo" @pressEnter="refresh()"/>-->
      <!--            </a-descriptions-item>-->
      <!--            <a-descriptions-item :label="$t('business.label.countingTask')">-->
      <!--              <vxe-switch :value="countingTask"/>-->
      <!--            </a-descriptions-item>-->
      <!--            <a-descriptions-item :span="1">-->
      <!--              <span slot="label" class="supervisedFont">{{$t('business.label.restInventory')}}</span>-->
      <!--              <span class="supervisedFont">{{restInventoryQuantity}}</span>-->
      <!--            </a-descriptions-item>-->
      <!--          </a-descriptions>-->
      <template #extra>
        <vxe-button content="button.allocatePackingPosition" status="primary" @click="allocatePackingPosition"/>
        <vxe-button content="button.release" status="danger" @click="release"/>
      </template>
      <div class="card-container">
        <div class="left-slot">
          <slot name="left">
            <vxe-row>
              <vxe-col span="16">
                <vxe-form
                  :data="selectedCmd"
                  :items="commandItems"
                  @keydown.enter.native="handleEnter"
                />
              </vxe-col>
              <vxe-col span="10">
                <vxe-image :src="require('@/assets/yaopin.jpeg')" alt="example" width="80%"/>
              </vxe-col>
            </vxe-row>
            <vxe-row>
              <vxe-col>
                <vxe-table
                  ref="table1"
                  :data="data1"
                  :export-config="{}"
                  :height="screenHeight * (0.41)"
                  :keyboard-config="{isArrow: true}"
                  :loading="loading1"
                  :row-class-name="setRowClassName"
                  :row-config="{isCurrent: true, isHover: true}"
                  :column-config="{resizable: true}"
                  :scroll-x="{enabled: true}"
                  align="center"
                  border
                  round
                  show-header-overflow
                  show-overflow
                  size="mini"
                  stripe
                  @cell-click="({row})=>commandSelect(row)">
                  <vxe-column fixed="left" type="seq" width="40"/>
                  <vxe-column field="command.commandStatus" title="button.review" width="70">
                    <vxe-switch slot-scope="{row}" :value="row.command.commandStatus>=34"/>
                  </vxe-column>
                  <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
                  <vxe-column field="item.name" title="business.label.itemName" width="150"/>
                  <vxe-column field="lot.no" title="business.label.lot" width="150"/>
                  <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
                  <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
                  <vxe-column field="command.actualQuantity" title="business.label.quantity" width="60"/>
                  <vxe-column field="seedingPosition.no" title="business.label.seedingPosition" width="80"/>
                  <vxe-column field="packingPosition.no" title="business.label.packingPosition" width="80"/>
                  <operate-column :fixed-buttons="commandButtons" :min-width="300"/>
                </vxe-table>
              </vxe-col>
            </vxe-row>
          </slot>
        </div>
        <div class="right-slot">
          <slot name="right">
            <vxe-row vertical>
              <vxe-col>
                <vxe-table
                  ref="table2"
                  :data="data2"
                  :height="screenHeight * (0.2)"
                  :keyboard-config="{isArrow: true}"
                  :loading="loading2"
                  :row-config="{isCurrent: true, isHover: true}"
                  :column-config="{resizable: true}"
                  :scroll-x="{enabled: true}"
                  align="center"
                  border
                  round
                  show-header-overflow
                  show-overflow
                  size="mini"
                  stripe>
                  <vxe-column field="item.name" title="business.label.itemName" width="40%"/>
                  <vxe-column field="pack.specification" title="business.label.specification" width="25%"/>
                  <vxe-column field="lot.no" title="business.label.lot" width="20%"/>
                  <vxe-column field="inventory.quantity" title="business.label.quantity" width="15%"/>
                </vxe-table>
              </vxe-col>
              <vxe-col>
                <vxe-table
                  ref="table3"
                  :checkbox-config="{trigger: 'row'}"
                  :data="data3"
                  :export-config="{}"
                  :height="screenHeight * (0.5825)"
                  :keyboard-config="{isArrow: true}"
                  :loading="loading3"
                  :row-config="{isCurrent: true, isHover: true}"
                  :column-config="{resizable: true}"
                  :scroll-x="{enabled: true}"
                  align="center"
                  border
                  round
                  show-header-overflow
                  show-overflow
                  size="mini"
                  stripe
                  style="margin-top: 2px">
                  <vxe-column fixed="left" type="checkbox" width="40"/>
                  <vxe-column field="no" title="business.label.supervisionCode"/>
                  <vxe-column field="collectTime" title="business.label.collectTime" width="170"/>
                  <vxe-column :cell-render="{name:'FormatSelect',options:appearances}" field="appearance" title="business.label.appearance"/>
                  <operate-column :fixed-buttons="barcodeButtons"/>
                </vxe-table>
              </vxe-col>
            </vxe-row>
          </slot>
        </div>
      </div>
      <!--        <div class="grid-section">-->
      <!--          <div class="grid-item form-item">-->
      <!--            <vxe-form-->
      <!--              :data="selectedCmd"-->
      <!--              :items="commandItems"-->
      <!--              @keydown.enter.native="handleEnter"-->
      <!--            />-->
      <!--          </div>-->
      <!--          <div class="grid-item image-item">-->
      <!--            <vxe-image alt="example" :src="require('@/assets/yaopin.jpeg')" width="90%" height="90%"/>-->
      <!--          </div>-->
      <!--          <div class="grid-item table-item">-->
      <!--            <vxe-table-->
      <!--              ref="table3"-->
      <!--              :checkbox-config="{trigger: 'row'}"-->
      <!--              :data="data3"-->
      <!--              :export-config="{}"-->
      <!--              :keyboard-config="{isArrow: true}"-->
      <!--              :loading="loading3"-->
      <!--              :row-config="{isCurrent: true, isHover: true}"-->
      <!--      :column-config="{resizable: true}"-->
      <!--              :scroll-x="{enabled: true}"-->
      <!--              align="center"-->
      <!--              border-->
      <!--              round-->
      <!--              show-header-overflow-->
      <!--              show-overflow-->
      <!--              size="mini"-->
      <!--              stripe-->
      <!--              style="margin-top: 2px">-->
      <!--              <vxe-column fixed="left" type="checkbox" width="40"/>-->
      <!--              <vxe-column field="no" title="business.label.supervisionCode"/>-->
      <!--              <vxe-column field="collectTime" title="business.label.collectTime" width="170"/>-->
      <!--              <vxe-column :cell-render="{name:'FormatSelect',options:appearances}" field="appearance" title="business.label.appearance"/>-->
      <!--              <operate-column :fixed-buttons="barcodeButtons"/>-->
      <!--            </vxe-table>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--          <div class="footer-section">-->
      <!--            <div class="grid-item form-item">-->
      <!--              <vxe-table-->
      <!--                ref="table1"-->
      <!--                :data="data1"-->
      <!--                :export-config="{}"-->
      <!--                :keyboard-config="{isArrow: true}"-->
      <!--                :loading="loading1"-->
      <!--                :row-class-name="setRowClassName"-->
      <!--                :row-config="{isCurrent: true, isHover: true}"-->
      <!--      :column-config="{resizable: true}"-->
      <!--                :scroll-x="{enabled: true}"-->
      <!--                align="center"-->
      <!--                border-->
      <!--                round-->
      <!--                show-header-overflow-->
      <!--                show-overflow-->
      <!--                size="mini"-->
      <!--                stripe-->
      <!--                @cell-click="({row})=>commandSelect(row)">-->
      <!--      <vxe-column fixed="left" type="seq" width="40"/>-->
      <!--                <vxe-column field="command.commandStatus" title="button.review" width="70">-->
      <!--                  <vxe-switch slot-scope="{row}" :value="row.command.commandStatus>=34"/>-->
      <!--                </vxe-column>-->
      <!--                <vxe-column field="item.no" title="business.label.itemNo" width="80"/>-->
      <!--                <vxe-column field="item.name" title="business.label.itemName" width="150"/>-->
      <!--                <vxe-column field="lot.no" title="business.label.lot" width="150"/>-->
      <!--                <vxe-column field="pack.uom" title="business.label.uom" width="60"/>-->
      <!--                <vxe-column field="pack.factor" title="business.label.factor" width="60"/>-->
      <!--                <vxe-column field="command.actualQuantity" title="business.label.quantity" width="60"/>-->
      <!--                <vxe-column field="seedingPosition.no" title="business.label.seedingPosition" width="80"/>-->
      <!--                <vxe-column field="packingPosition.no" title="business.label.packingPosition" width="80"/>-->
      <!--                <operate-column :fixed-buttons="commandButtons" :min-width="300"/>-->
      <!--              </vxe-table>-->
      <!--            </div>-->
      <!--            <div class="grid-item form-item">-->
      <!--              <vxe-table-->
      <!--                ref="table2"-->
      <!--                :data="data2"-->
      <!--                :keyboard-config="{isArrow: true}"-->
      <!--                :loading="loading2"-->
      <!--                :row-config="{isCurrent: true, isHover: true}"-->
      <!--      :column-config="{resizable: true}"-->
      <!--                :scroll-x="{enabled: true}"-->
      <!--                align="center"-->
      <!--                border-->
      <!--                round-->
      <!--                show-header-overflow-->
      <!--                show-overflow-->
      <!--                size="mini"-->
      <!--                stripe>-->
      <!--                <vxe-column field="item.name" title="business.label.itemName"/>-->
      <!--                <vxe-column field="pack.specification" title="business.label.specification"/>-->
      <!--                <vxe-column field="lot.no" title="business.label.lot"/>-->
      <!--                <vxe-column field="inventory.quantity" title="business.label.quantity"/>-->
      <!--              </vxe-table>-->
      <!--            </div>-->
      <!--          </div>-->
    </vxe-card>
    <!--      <a-row style="margin-top: 2px">-->
    <!--        <a-col :span="14">-->
    <!--          <a-descriptions :column="6" style="margin-bottom: -15px">-->
    <!--            <a-descriptions-item :label="$t('business.label.itemNo')" span="2">{{this.selectedCmd.item.no}}</a-descriptions-item>-->
    <!--            <a-descriptions-item>-->
    <!--              <span v-if="this.selectedCmd.item.fallible" class="supervisedFont">{{$t('business.label.fallible')}}</span>-->
    <!--              <span v-else class="ignoreFont">{{$t('business.label.fallible')}}</span>-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item>-->
    <!--              <span v-if="this.selectedCmd.supervised" class="supervisedFont">{{$t('business.label.supervised')}}</span>-->
    <!--              <span v-else class="ignoreFont">{{$t('business.label.supervised')}}</span>-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item>-->
    <!--              <span v-if="this.selectedCmd.item.valuable" class="supervisedFont">{{$t('business.label.valuable')}}</span>-->
    <!--              <span v-else class="ignoreFont">{{$t('business.label.valuable')}}</span>-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item>-->
    <!--              <span v-if="multipleItems" class="supervisedFont">{{$t('business.label.multiple')}}</span>-->
    <!--              <span v-else class="ignoreFont">{{$t('business.label.multiple')}}</span>-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item span="3">-->
    <!--              <span slot="label" class="supervisedFont">{{$t('business.label.itemName')}}</span>-->
    <!--              <span class="supervisedFont">{{this.selectedCmd.item.name}}</span>-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item span="3">-->
    <!--              <span slot="label" class="supervisedFont">{{$t('business.label.itemBarcode')}}</span>-->
    <!--              <a-input v-model="itemBarcode" style="width: 150%;" @pressEnter="searchData1"/>-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item :label="$t('business.label.specification')" span="2">-->
    <!--              {{this.selectedCmd.pack.specification}}-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item :label="$t('business.label.uom')" span="1">-->
    <!--              {{this.selectedCmd.pack.uom}}-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item :label="$t('business.label.factor')" span="1">-->
    <!--              {{this.selectedCmd.pack.factor}}-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item :label="$t('business.label.appendageSign')" span="2">-->
    <!--              <vxe-select v-model="selectedCmd.command.appendageSign" :options="appendageSigns" />-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item span="2">-->
    <!--              <span slot="label" class="supervisedFont">{{$t('business.label.lot')}}</span>-->
    <!--              <span class="specialFont">{{this.selectedCmd.lot.no}}</span>-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item :label="$t('business.label.productionDate')" span="1">-->
    <!--              {{this.selectedCmd.lot.productionDate}}-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item :label="$t('business.label.validUntil')" span="1">-->
    <!--              {{this.selectedCmd.lot.validUntil}}-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item :label="$t('business.label.manufacturer')" span="2">-->
    <!--              {{this.selectedCmd.lot.manufacturer}}-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item span="3">-->
    <!--              <span slot="label" class="supervisedFont">{{$t('business.label.seedingQuantity')}}</span>-->
    <!--              <a-input-number ref="seedingQtyInput" v-model="selectedCmd.command.actualQuantity" :max="maxQuantity" :min="0" style="width: 100%;-->
    <!--              font-weight: bold;-->
    <!--              font-size: 20px;-->
    <!--              color: red;" @pressEnter="seedingQtyInputPressEnter"/>-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item span="3">-->
    <!--              <span slot="label" class="supervisedFont">{{$t('business.label.reviewQuantity')}}</span>-->
    <!--              <a-input-number ref="reviewQtyInput" v-model="seedingConfirmQuantity" :max="maxQuantity" :min="0" style="width: 100%;-->
    <!--              font-weight: bold;-->
    <!--              font-size: 20px;-->
    <!--              color: red;" @pressEnter="commandConfirm"/>-->
    <!--            </a-descriptions-item>-->
    <!--          </a-descriptions>-->
    <!--        </a-col>-->
    <!--        <a-col :span="10" style="margin-top: 2px">-->
    <!--          <a-divider>{{$t('title.SupervisionCodeCollection')}}</a-divider>-->
    <!--          <a-descriptions :column="5" style="margin-top: -15px;margin-bottom: -15px">-->
    <!--            <a-descriptions-item :label="$t('business.label.barcode')" span="3">-->
    <!--              <a-space>-->
    <!--                <a-input v-model="superviseBarcode" @pressEnter="scanSupervisedBarcode"/>-->
    <!--                <a-button type="primary" @click="clearSupervisedBarcode">{{$t('button.clear')}}</a-button>-->
    <!--              </a-space>-->
    <!--            </a-descriptions-item>-->
    <!--            <a-descriptions-item :label="$t('business.label.collectQuantity')">-->
    <!--              <span class="normalFont">{{supervisedCount}}/{{this.selectedCmd.command.actualQuantity ? this.selectedCmd.command.actualQuantity : 0}}</span>-->
    <!--            </a-descriptions-item>-->
    <!--          </a-descriptions>-->
    <!--        </a-col>-->
    <!--      </a-row>-->
    <SeedingItemMaintainModal ref="seedingItemMaintainModal"/>
  </div>
</template>

<script>
import Vue from 'vue'
import Api from '@/api'
import { findAll, findEnum, post } from '@/api/Api'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { ShippingFactoryView } from '@/api/dto/view/ShippingFactoryView'
import SeedingItemMaintainModal from '@/views/outbound/view_seeding/modal/SeedingItemMaintainModal.vue'
import moment from 'moment'
import OperateColumn from '@/views/admin/OperateColumn.vue'
import CompactForm from '@/views/admin/CompactForm.vue'

export default {
  name: 'ViewSeedingTaskDetail',
  components: { CompactForm, OperateColumn, SeedingItemMaintainModal },
  props: {
    positionTypeId: { type: String, default: '' }
  },
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      loading1: false,
      loading2: false,
      loading3: false,
      data1: [],
      data2: [],
      data3: [],
      zoneNo: '',
      containerNo: '',
      itemBarcode: '',
      reviewer2: '',
      selectedCmd: new ShippingFactoryView(),
      countingTask: false,
      maxQuantity: 0,
      seedingConfirmQuantity: null,
      restInventoryQuantity: null,
      multipleItems: false,
      supervisedCount: 0,
      superviseBarcode: '',
      appearances: [],
      appendageSigns: [],
      screenHeight: Vue.ls.get(SCREEN_HEIGHT),
      taskData: {
        zoneNo: '',
        containerNo: '',
        countingTask: false,
        restInventoryQuantity: 0
      },
      taskItems: [
        {
          field: 'zoneNo',
          title: 'business.label.workstation',
          itemRender: {
            name: 'VxeInput'
          }
        },
        {
          field: 'containerNo',
          title: 'business.label.scanContainer',
          itemRender: {
            name: 'VxeInput'
          }
        },
        {
          field: 'countingTask',
          title: 'business.label.countingTask',
          itemRender: {
            name: 'VxeSwitch'
          }
        },
        {
          field: 'restInventoryQuantity',
          title: 'business.label.restInventory',
          itemRender: {
            name: 'VxeInput',
            props: {
              className: 'special-input'
            }
          }
        }
      ],
      commandButtons: [
        {
          content: 'button.review',
          click: (row) => this.commandConfirm(row),
          disabled: (row) => row.command.commandStatus >= 34
        },
        {
          content: 'button.seedingConfirm',
          click: (row) => this.seedingConfirm(row),
          disabled: (row) => row.command.commandStatus !== 34
        },
        {
          content: 'button.split',
          click: (row) => this.split(row)
        },
        {
          content: 'button.updateSeedingQuantity',
          click: (row) => this.updateSeedingItem(row)
        }
      ],
      barcodeButtons: [
        {
          content: 'button.delete',
          click: (row) => this.deleteSupervisedBarcode(row)
        }
      ]
    }
  },
  computed: {
    commandItems() {
      return [
        {
          title: this.$t('business.label.itemNo'),
          field: 'itemNo',
          span: 8,
          itemRender: {
            name: '$input',
            props: { disabled: true }
          }
        },
        {
          title: this.$t('business.label.fallible'),
          field: 'fallible',
          span: 4,
          itemRender: {
            name: '$span',
            content: this.$t('business.label.fallible'),
            props: {
              className: ({ data }) => this.getStatusClass('fallible', data.fallible)
            }
          }
        },
        {
          title: this.$t('business.label.supervised'),
          field: 'supervised',
          span: 4,
          itemRender: {
            name: '$span',
            content: this.$t('business.label.supervised'),
            props: {
              className: ({ data }) => this.getStatusClass('supervised', data.supervised)
            }
          }
        },
        {
          title: this.$t('business.label.valuable'),
          field: 'valuable',
          span: 4,
          itemRender: {
            name: '$span',
            content: this.$t('business.label.valuable'),
            props: {
              className: ({ data }) => this.getStatusClass('valuable', data.valuable)
            }
          }
        },
        {
          title: this.$t('business.label.multiple'),
          field: 'multipleItems',
          span: 4,
          itemRender: {
            name: '$span',
            content: this.$t('business.label.multiple'),
            props: {
              className: ({ data }) => this.getStatusClass('multiple', data.multipleItems)
            }
          }
        },
        {
          title: {
            content: this.$t('business.label.itemName'),
            className: 'supervisedFont'
          },
          field: 'itemName',
          span: 12,
          itemRender: {
            name: '$span',
            content: '',
            props: {
              className: 'supervisedFont'
            }
          }
        },
        {
          title: {
            content: this.$t('business.label.itemBarcode'),
            className: 'supervisedFont'
          },
          field: 'itemBarcode',
          span: 12,
          itemRender: {
            name: '$input',
            props: {
              placeholder: '输入条形码',
              style: { width: '150%' }
            },
            events: {
              keydown: this.searchData1
            }
          }
        },
        {
          title: this.$t('business.label.specification'),
          field: 'specification',
          span: 8,
          itemRender: {
            name: '$span',
            content: '',
            props: { disabled: true }
          }
        },
        {
          title: this.$t('business.label.uom'),
          field: 'uom',
          span: 4,
          itemRender: {
            name: '$span',
            content: '',
            props: { disabled: true }
          }
        },
        {
          title: this.$t('business.label.factor'),
          field: 'factor',
          span: 4,
          itemRender: {
            name: '$span',
            content: '',
            props: { disabled: true }
          }
        },
        {
          title: this.$t('business.label.appendageSign'),
          field: 'appendageSign',
          span: 8,
          itemRender: {
            name: '$select',
            options: [],
            props: {
              placeholder: '请选择'
            }
          }
        },
        {
          title: {
            content: this.$t('business.label.lot'),
            className: 'supervisedFont'
          },
          field: 'lot',
          span: 8,
          itemRender: {
            name: '$span',
            content: '',
            props: {
              className: 'specialFont'
            }
          }
        },
        {
          title: this.$t('business.label.productionDate'),
          field: 'productionDate',
          span: 4,
          itemRender: {
            name: '$span',
            content: '',
            props: { disabled: true }
          }
        },
        {
          title: this.$t('business.label.validUntil'),
          field: 'validUntil',
          span: 4,
          itemRender: {
            name: '$span',
            content: '',
            props: { disabled: true }
          }
        },
        {
          title: this.$t('business.label.manufacturer'),
          field: 'manufacturer',
          span: 8,
          itemRender: {
            name: '$span',
            content: '',
            props: { disabled: true }
          }
        },
        {
          title: {
            content: this.$t('business.label.seedingQuantity'),
            className: 'supervisedFont'
          },
          field: 'seedingQuantity',
          span: 12,
          itemRender: {
            name: '$input',
            props: {
              type: 'number',
              min: 0,
              max: 999999,
              style: {
                width: '100%',
                fontWeight: 'bold',
                fontSize: '20px',
                color: 'red'
              }
            },
            events: {
              keydown: this.seedingQtyInputPressEnter
            }
          }
        },
        {
          title: {
            content: this.$t('business.label.reviewQuantity'),
            className: 'supervisedFont'
          },
          field: 'reviewQuantity',
          span: 12,
          itemRender: {
            name: '$input',
            props: {
              type: 'number',
              min: 0,
              max: 999999,
              style: {
                width: '100%',
                fontWeight: 'bold',
                fontSize: '20px',
                color: 'red'
              }
            },
            events: {
              keydown: this.commandConfirm
            }
          }
        }
      ]
    }
  },
  created() {
    findEnum('Appearance').then(res => {
      this.appearances = res.result.map(item => {
        return { label: item.name, value: item.ordinal }
      })
    })
    findEnum('AppendageSign').then(res => {
      this.appendageSigns = res.result.map(item => {
        return { label: item.name, value: item.ordinal }
      })
    })
  },
  methods: {
    moment,
    // 统一的样式类名处理方法
    getStatusClass(type, value) {
      // 根据不同类型和值返回对应的样式类名
      const statusMap = {
        fallible: value ? 'supervisedFont' : 'ignoreFont',
        supervised: value ? 'supervisedFont' : 'ignoreFont',
        valuable: value ? 'supervisedFont' : 'ignoreFont',
        multiple: value ? 'supervisedFont' : 'ignoreFont'
      }
      return statusMap[type] || ''
    },
    onSelect1Change(record) {
      this.$refs.table1.setRadioRow(record)
      this.$refs.table1.setCurrentRow(record)
    },
    onPressEnterZoneNo() {
      if (this.zoneNo === undefined || this.zoneNo === '' || this.zoneNo === null) {
        return this.$warning({
          title: '工作站不能为空',
          content: '请输入或扫描工作站编号',
          centered: true,
          okText: '确定'
        })
      }
      this.clearData()
      this.$nextTick(() => {
        this.$refs.containerNo.focus()
      })
    },
    refresh() {
      if (this.zoneNo === undefined || this.zoneNo === '' || this.zoneNo === null) {
        return this.$warning({
          title: '工作站不能为空',
          content: '请输入或扫描工作站编号',
          centered: true,
          okText: '确定'
        })
      }
      if (this.containerNo === undefined || this.containerNo === '' || this.containerNo === null) {
        return this.$warning({
          title: '容器号不能为空',
          content: '请输入或扫描容器编号',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      this.getSeedingTaskDetail().then(res1 => {
        if (res1.success) {
          if (res1.result.length > 0) {
            this.data1 = res1.result
            this.commandSelect(this.data1[0])
            this.isMultipleItemsAndConfirmed()
            this.loading = false
            this.getContainerRestInventory().then(() => this.getRestInventoryQuantity())
          } else {
            this.obtain().then(res2 => {
              if (res2.success) {
                this.getSeedingTaskDetail().then(res3 => {
                    if (res3.success) {
                      if (res3.result.length > 0) {
                        this.data1 = res3.result
                        this.commandSelect(this.data1[0])
                        this.isMultipleItemsAndConfirmed()
                      }
                      this.getContainerRestInventory().then(() => this.getRestInventoryQuantity())
                    }
                  }
                ).finally(() => this.loading = false)
              } else {
                this.loading = false
              }
            })
          }
        } else {
          this.loading = false
        }
      })
    },
    obtain() {
      const args = { 'container.no': this.containerNo, 'zone.no': this.zoneNo }
      return post(Api.seedingObtain, { type: 'containerObtainer' }, args)
    },
    getSeedingTaskDetail() {
      const args = { 'container.no': this.containerNo, 'zone.no': this.zoneNo, seeding: true, completed: false }
      return findAll('seedingTaskDetailFactory', args)
    },
    getContainerRestInventory() {
      const args = { 'container.no': this.containerNo }
      return findAll('seedingInventoryFactory', args).then(res => {
        if (res.success) {
          this.data2 = res.result
        }
      }).then(() => this.loading2 = false)
    },
    getRestInventoryQuantity() {
      const seedingQuantity = this.data1.reduce((acc, item) => acc + item.command.actualQuantity, 0)
      const restInventoryQuantity = this.data2.reduce((acc, item) => acc + item.inventory.quantity, 0)
      this.restInventoryQuantity = seedingQuantity + restInventoryQuantity
    },
    setRowClassName({ row }) {
      if (row) {
        return row.command.commandStatus >= 34 ? 'confirmed' : ''
      }
      return ''
    },
    commandSelect(record) {
      this.selectedCmd = record
      this.maxQuantity = record.command.actualQuantity
      this.seedingConfirmQuantity = record.command.actualQuantity
      this.onSelect1Change(record)
      this.$nextTick(() => {
        this.$refs.reviewQtyInput.focus()
      })
    },
    isMultipleItemsAndConfirmed() {
      if (this.data1.length > 1) {
        const arr = this.data1.map(item => {
          return item.item.id
        })
        this.multipleItems = new Set(arr).size > 1
      } else {
        this.multipleItems = false
      }
    },
    // 指令复核确认
    commandConfirm(row) {
      if (this.seedingConfirmQuantity === null || this.seedingConfirmQuantity === undefined || this.seedingConfirmQuantity === 0) {
        return this.$warning({
          title: '复核数量需大于0',
          content: '请确认复核数量',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      let args = {
        'command.id': row.command.id,
        actualQuantity: this.seedingConfirmQuantity,
        appendageSign: 1,
        operationType: 2,
        largePack: [],
        mediumPack: [],
        smallPack: []
      }
      this.data3.forEach(item => {
        if (item.appearance === 1) {
          args.largePack.push({ 'no': item.no, 'appearance': 1 })
        } else if (item.appearance === 2) {
          args.mediumPack.push({ 'no': item.no, 'appearance': 2 })
        } else if (item.appearance === 3) {
          args.smallPack.push({ 'no': item.no, 'appearance': 3 })
        }
      })
      post(Api.seedingObtain, { type: 'commandObtainer' }, args).then(res => {
          if (res.success) {
            this.$message.success('复核成功')
            this.reloadData1()
          }
        }
      ).finally(() => this.loading = false)
    },
    //分配打包位
    allocatePackingPosition() {
      if (this.zoneNo === undefined || this.zoneNo === '' || this.zoneNo === null) {
        return this.$warning({
          title: '工作站不能为空',
          content: '请输入或扫描工作站编号',
          centered: true,
          okText: '确定'
        })
      }
      if (this.containerNo === undefined || this.containerNo === '' || this.containerNo === null) {
        return this.$warning({
          title: '容器号不能为空',
          content: '请输入或扫描容器编号',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      let allocateArgs = { 'barcode': this.containerNo, 'siteNo': this.zoneNo }
      post(Api.containerAllocateMatrixPackingPosition, { type: 'generalHandler' }, allocateArgs).then(res => {
        if (res.success) {
          this.$message.success('分配成功')
          this.reloadData1()
        }
      }).finally(() => this.loading = false)
    },
    split(row) {
      this.loading = true
      const args = { 'command.id': row.command.id, 'quantity': row.command.actualQuantity }
      post(Api.seedingSplit, {}, args).then(res => {
        if (res.success) {
          this.$message.success('拆分成功')
          this.reloadData1()
        }
      }).finally(() => this.loading = false)
    },
    updateSeedingItem(row) {
      this.$refs.seedingItemMaintainModal.open(row.item.id)
    },
    seedingConfirm(row) {
      this.loading = true
      const args = { 'command.id': row.command.id }
      post(Api.seedingConfirm, { type: 'commandConfirmer' }, args).then(res => {
        if (res.success) {
          this.$message.success('确认成功')
          this.reloadData1()
        }
      }).finally(() => this.loading = false)
    },
    log() {
    },
    release() {
      if (this.zoneNo === undefined || this.zoneNo === '' || this.zoneNo === null) {
        return this.$warning({
          title: '工作站不能为空',
          content: '请输入或扫描工作站编号',
          centered: true,
          okText: '确定'
        })
      }
      if (this.containerNo === undefined || this.containerNo === '' || this.containerNo === null) {
        return this.$warning({
          title: '容器号不能为空',
          content: '请输入或扫描容器编号',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      let taskArgs = { 'workstation.no': this.zoneNo, 'container.no': this.containerNo }
      post(Api.seedingRelease, { type: 'generalHandler' }, taskArgs).then(res => {
        if (res.success) {
          this.$message.success('放行成功')
          this.clearData()
        }
      }).finally(() => this.loading = false)
    },
    reloadData1() {
      this.loading1 = true
      this.clearSupervisedBarcode()
      this.getSeedingTaskDetail().then(res => {
          if (res.success) {
            if (res.result.length === 0) {
              const zoneNo = this.zoneNo
              this.clearData()
              this.zoneNo = zoneNo
              this.$refs.containerNo.focus()
            } else {
              this.commandSelect(res.result[0])
              this.data1 = res.result
            }
          }
        }
      ).finally(() => this.loading1 = false)
    },
    //扫描监管码
    scanSupervisedBarcode() {
      if (this.selectedCmd.command.actualQuantity === undefined || this.selectedCmd.command.actualQuantity === null || this.selectedCmd.command.actualQuantity === 0) {
        this.superviseBarcode = ''
        return this.$warning({
          title: '无任务可采集监管码',
          content: '请确定已索取到分播任务',
          centered: true,
          okText: '确定'
        })
      }
      if (this.supervisedCount + 1 > this.selectedCmd.command.actualQuantity) {
        this.superviseBarcode = ''
        return this.$warning({
          title: '采集数量超出任务数量',
          content: '请确定已采集数量',
          centered: true,
          okText: '确定'
        })
      } else {
        this.supervisedCount++
      }
      this.data3.push({
        key: this.data3.length + 1,
        no: this.superviseBarcode,
        collectTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        appearance: 3
      })
      this.superviseBarcode = ''
    },
    clearSupervisedBarcode() {
      this.data3 = []
      this.supervisedCount = 0
      this.superviseBarcode = ''
    },
    deleteSupervisedBarcode(row) {
      this.data3.splice(this.data3.indexOf(row), 1)
    },
    seedingQtyInputPressEnter() {
      this.seedingConfirmQuantity = this.selectedCmd.command.actualQuantity
      this.$refs.reviewQtyInput.focus()
    },
    searchData1() {
      this.loading1 = true
      setTimeout(() => {
        let filterData = this.data1.filter(item => item.item.barcodes.includes(this.itemBarcode))
        if (filterData.length > 0) {
          this.commandSelect(filterData[0])
        }
        this.loading1 = false
      }, 400)
    },
    clearData() {
      this.data1 = []
      this.data2 = []
      this.data3 = []
      this.selectedCmd = new ShippingFactoryView()
      this.restInventoryQuantity = null
      this.seedingConfirmQuantity = null
      this.maxQuantity = 0
      this.containerNo = ''
      this.itemBarcode = ''
      this.superviseBarcode = ''
      this.supervisedCount = 0
      this.multipleItems = false
    }
  }
}
</script>

<style scoped>
.card-container {
  display: flex;
  width: 100%;
  min-height: 400px;
}

.left-slot {
  flex: 7; /* 70% */
  min-width: 0; /* 防止内容溢出 */
  overflow: clip; /* 内容过多时显示滚动条 */
  padding-right: 4px;
  border-right: 1px solid #e8e8e8; /* 可选分隔线 */
}

.right-slot {
  flex: 3; /* 30% */
  min-width: 0; /* 防止内容溢出 */
  overflow: clip; /* 内容过多时显示滚动条 */
  padding-left: 4px;
}

/* 确保两个插槽高度一致 */
.left-slot, .right-slot {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.specialFont {
  font-weight: bold;
  font-size: 18px;
  color: red;
}

.normalFont {
  font-weight: bold;
  font-size: 18px;
  color: #404040;
}

.ignoreFont {
  font-weight: bold;
  font-size: 22px;
  color: #837D7DFF;
}

.supervisedFont {
  font-weight: bold;
  font-size: 20px;
  color: red;
}
</style>